import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-sfc-night px-5">
      <div data-testid="payment-cancel" className="w-full max-w-md rounded-3xl border border-white/10 bg-white/[0.03] p-10 text-center">
        <XCircle className="mx-auto text-sfc-yellow" size={54} />
        <h1 className="mt-5 font-display text-2xl text-white">Betaling geannuleerd</h1>
        <p className="mt-3 text-white/70">U heeft de betaling geannuleerd. Uw order blijft bewaard — u kunt op een later moment alsnog betalen via de link in uw e-mail.</p>
        <Link to="/" className="mt-8 inline-block rounded-full bg-gradient-to-r from-sfc-orange to-sfc-red px-7 py-3 text-sm font-semibold text-white">Terug naar home</Link>
      </div>
    </div>
  );
}
